export default __webpack_public_path__ + "owner-verification-medal.png?a4599f6b4ccc10eac06b60872163785c";